import React, {Fragment, PureComponent} from "react";
import { connect } from "react-redux";
import Sound from 'react-sound';
import * as Noty from 'noty';
import { compose } from "redux";
import { withTranslation } from "react-i18next";

import * as styles from "./style.css";
import UQButton from "../../../../uq-ui/components/button";
import { mediaAudioStateSelector } from "../../../store/media-audio/selectors";
import {
  onAudioDone,
  onAudioRecorded,
  resetAudioInfo,
  setAudioDuration,
} from "../../../store/media-audio/actions";
import Icon from "../../../../icons/Icon";
import { StickerFormatEnum } from "../../../domain/enums/StickerFormatEnum";
import StickersComponentsTryAgainBtn from "../../components/try-again-btn";
import { getDurationString } from "../../../../uq-ui/helpers/duration";
import Div100vh from "../../../../uq-ui/components/div-100";
import {
  createLlamaIdSelector,
  createLlamaShowAnimationSelector,
  createStickerIdSelector, createStickerItemIdSelector
} from "../../../store/create-llama/selectors";
import goolgeAnalytics from '../../../../user/analytics/GoogleAnalytics';
import { isMemorialType } from "../../../store/sticker-show/selectors";

const Bottom = require('./img/bottom.png');
const Bottom2x = require('./img/bottom@2x.png');
const BalloonLeft = require('./img/balloon-left.png');
const BalloonLeft2x = require('./img/balloon-left@2x.png');
const BalloonRight = require('./img/balloon-right.png');
const BalloonRight2x = require('./img/balloon-right@2x.png');

const Record = require('./img/record.png');
const Stop = require('./img/stop.png');
const Play = require('./img/play.png');
const PlayDark = require('./img/play-dark.png');

class StickersScreensNewStickerMediaAudio extends PureComponent {

  durationIntervalTimer = null;

  recorder;
  gumStream;

  constructor(props) {
    super(props);
    this.state = {
      isRecording: false,
      isPlaying: false,
      currentDuration: 0
    };
  }

  componentDidMount() {
    goolgeAnalytics.setCurrentScreen('web-new-sticker-media-audio');
  }

  componentWillUnmount() {
    this.clearDurationTimer();
  }

  onBackPressed = () => {
    this.props.history.push(`/stickers/${this.props.stickerId}/new`);
  };

  onTryAgainPressed = (event) => {
    this.setState({ currentDuration: 0, isPlaying: false, isRecording: false });
    this.props.resetAudioInfo();
    this.clearDurationTimer();
  };

  onDonePressed = () => {
    this.props.onAudioDone();
  };

  onRecordPressed = () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then((stream) => {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const inputStream = audioContext.createMediaStreamSource(stream);
        this.gumStream = stream;
        this.recorder = new Recorder(inputStream, { numChannels: 1 });
        this.recorder.record();

        this.setState({ isRecording: true });
        this.startDurationTimer();
      }).catch((error) => {
        new Noty({
          type: 'error',
          timeout: 4000,
          text: this.props.t('errors.microphoneAccess'),
        }).show();
        });
    } else {
      new Noty({
        type: 'error',
        timeout: 4000,
        text: this.props.t('errors.browserSupport'),
      }).show();
    }
  };

  onStopPressed = () => {
    if (this.state.isRecording) {
      this.recorder.stop();
      //stop microphone access
      this.gumStream.getAudioTracks()[0].stop();
      //create the wav blob and pass it on to createDownloadLink
      this.recorder.exportWAV((blob) => {
        // hot check
        if (blob.size > 44) {
          const urlCreator = window.URL || window.webkitURL;
          const uri = urlCreator.createObjectURL(blob);
          this.props.onAudioRecorded({ blob, uri });
          this.props.setAudioDuration(this.state.currentDuration);
        } else {
          new Noty({
            type: 'error',
            timeout: 4000,
            text: this.props.t('errors.browserSupport'),
          }).show();
        }
        this.clearDurationTimer();
        this.setState({ isRecording: false, currentDuration: 0 });
      });

    } else if (this.state.isPlaying) {
      this.setState({ currentDuration: 0, isPlaying: false, isRecording: false });
    }
  };

  onPlayRecordPressed = () => {
    this.setState({ isPlaying: true });
  };

  onPlaying = ({ position }) => {
    this.setState({ currentDuration: position / 1000 });
  };

  onFinishPlaying = () => {
    this.setState({ isPlaying: false });
  };

  startDurationTimer = () => {
    this.durationIntervalTimer = setInterval(() => {
      this.setState({ currentDuration: this.state.currentDuration + 1 });
    }, 1000);
  };

  clearDurationTimer = () => {
    if (this.durationIntervalTimer) {
      clearInterval(this.durationIntervalTimer);
      this.durationIntervalTimer = null;
    }
  };

  _renderSound() {
    return (
      <Sound url={this.props.mediaState.originAudioPath}
             playStatus={Sound.status.PLAYING}
             autoPlay={true}
             onPlaying={this.onPlaying}
             onFinishedPlaying={this.onFinishPlaying}/>
    );
  }

  _renderDuration() {
    if ((this.state.isRecording || this.state.isPlaying) && this.state.currentDuration) {
      return getDurationString(this.state.currentDuration) || '0:00';
    }
    if (!this.state.isRecording && !this.state.isPlaying && this.props.mediaState.currentDuration != null) {
      return getDurationString(this.props.mediaState.currentDuration) || '0:00';
    }
    return null;
  }

  render() {
    return (
      <Div100vh className={styles.container} style={{ minHeight: '100rvh' }}>
        <button type="button"
                onClick={this.onBackPressed}
                className={ this.props.isMemorialTheme ? styles.headerBackBtn_memorial : styles.headerBackBtn }>
          <Icon name={ this.props.isMemorialTheme ? 'HeaderBackDarkBlue' : 'HeaderBackDark' } style={{width: "20px"}}/>
        </button>
        <Div100vh className={styles.inner} style={{ minHeight: '100rvh' }}>
          <div className={styles.header}>
            <div className={`${styles.title} font-title`} dangerouslySetInnerHTML={{ __html: this.props.t('title') }}/>
          </div>

          <div className={styles.recordingRow}>
            <div className={styles.recordingDuration}>
              {this._renderDuration()}
            </div>
            {this.props.mediaState.originAudioPath == null && !this.state.isRecording && (
              <div onClick={this.onRecordPressed}
                   className={styles.recordBtn}>
                <img src={Record} className={styles.iconRecord}/>
              </div>
            )}
            {(this.props.mediaState.originAudioPath != null && this.state.isPlaying || this.state.isRecording) && (
              <div onClick={this.onStopPressed}
                   className={styles.controlBtn}>
                <div className={styles.controlBtnInner}>
                  <img src={Stop} className={styles.iconStop}/>
                </div>
              </div>
            )}
            {this.props.mediaState.originAudioPath != null && !this.state.isPlaying && (
              <div onClick={this.onPlayRecordPressed} className={styles.controlBtn}>
                <div className={styles.controlBtnInner}>
                  <img src={ this.props.isMemorialTheme ? PlayDark : Play } className={styles.iconPlay}/>
                </div>
              </div>
            )}
          </div>

          {this.props.mediaState.originAudioPath != null && this.state.isPlaying && this._renderSound()}

          {this.props.mediaState.originAudioPath != null && (
            <div className={styles.doneControls}>
              <StickersComponentsTryAgainBtn
                onPress={this.onTryAgainPressed}
                format={StickerFormatEnum.Audio}/>
              <UQButton label={this.props.t('doneBtn')}
                        containerClass={styles.doneBtn}
                        containerStyle={{ minWidth: 140 }}
                        theme={ this.props.isMemorialTheme ? 'memorial' : 'whiteBrand' }
                        onPress={this.onDonePressed}/>
            </div>
          )}
        </Div100vh>
        {this.props.showAnimation && <Fragment>
          <img src={Bottom} srcSet={Bottom2x} className={styles.iconBottom}/>
          <img src={BalloonLeft} srcSet={BalloonLeft2x} className={styles.iconBalloonLeft}/>
          <img src={BalloonRight} srcSet={BalloonRight2x} className={styles.iconBalloonRight}/>
        </Fragment>}
        <Div100vh className={ this.props.isMemorialTheme ? styles.bg_memorial : styles.bg } style={{ minHeight: '100rvh' }}/>
      </Div100vh>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAudioDone: () => dispatch(onAudioDone()),
    resetAudioInfo: () => dispatch(resetAudioInfo()),
    setAudioDuration: (duration) => dispatch(setAudioDuration(duration)),
    onAudioRecorded: (audioInfo) => dispatch(onAudioRecorded(audioInfo))
  }
};

const mapStateToProps = (state) => {
  return {
    stickerId: createStickerIdSelector(state),
    stickerItemId: createStickerItemIdSelector(state),
    mediaState: mediaAudioStateSelector(state),
    showAnimation: createLlamaShowAnimationSelector(state),
    isMemorialTheme: isMemorialType(state),
  }
};

export default compose(
  withTranslation('scr-new-sticker-audio'),
  connect(mapStateToProps, mapDispatchToProps)
)(StickersScreensNewStickerMediaAudio);



// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/screens/new-sticker-media-audio/index.jsx